import http from "../http/http-config";
import { MobilityTypes } from "../models/mobilityTypes";

export default new class MobilityTypesService {
    getMobilityTypes(productId, securityGroup, onDate, correlationInformation, userName, userToken, tokenType): Promise<MobilityTypes[]> {
        return http.get<MobilityTypes[]>("MobilityTypes", {
            params: {
                productId,
                securityGroup,
                onDate,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}